/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

var SdxLoaderBar = require('sdx/loader/LoaderBar').default;

(function (Module, $) {
	'use strict';

	var INTERVAL_STEP = 50;

	/**
	 * Wrapper object for a Bar
	 */
	function Bar($bar) {
		var bar = new SdxLoaderBar($bar[0]);
		var fileSize = parseInt($bar.data('filesize'), 10) || 0;
		var internetSpeed = parseInt($bar.data('internetspeed'), 10) || 0;
		var $seconds = $bar.find('.seconds');
		var $name = $bar.find('.name');
		var title = $name.text();
		var fileSizeTranslationMb = $bar.data('file-size-translation-mb');
		var fileSizeTranslationGb = $bar.data('file-size-translation-gb');

		/**
		 * Calculates the duration in seconds, that are required to download fileSize with internetSpeed.
		 *
		 * @param fileSize - in Mega Bytes
		 * @param internetSpeed - in Mega Bits
		 * @returns {number} - float - seconds
		 */
		var getSeconds = function (fileSize, internetSpeed) {
			if(typeof fileSize === 'undefined' || typeof internetSpeed === 'undefined' || internetSpeed === 0) {
				return 0;
			}
			return fileSize / (internetSpeed / 8);
		};

		/**
		 * Format the time in format "X Min. X Sek."
		 *
		 * @param time
		 * @returns {string}
		 */
		var formatTime = function (time) {
			var min = Math.floor((time % 3600) / 60),
				seconds = time % 60;

			return (min > 0) ? min + ' ' + $bar.data('minutes') + ' ' + Math.round(seconds) + ' ' + $bar.data('seconds') : (Math.round(seconds * 10) / 10) + ' ' + $bar.data('seconds');
		};

		/**
		 * Format the file size in either MB or GB
		 *
		 * @param fileSize
		 * @returns {string}
		 */
		var formatFileSize = function(fileSize) {
			return (fileSize > 1000) ? '(' + String( fileSize / 1000 ) + ' ' + fileSizeTranslationGb + ')' : '(' + String( fileSize ) + ' ' + fileSizeTranslationMb + ')';
		};

		$.extend(this, {
			/**
			 * Update the user interface with the new file size and internet speed
			 *
			 * @param size
			 * @param speed
			 */
			updateUI: function (size, speed) {
				if (!size || !speed) {
					return;
				}

				var time = getSeconds(size, speed);
				$seconds.text(formatTime(time));
				$name.text(title + ' ' + formatFileSize(size));
			},

			/**
			 * Set a new file size
			 *
			 * @param newSize - Int
			 */
			setFileSize: function (newSize) {
				fileSize = newSize;
				this.updateUI(fileSize, internetSpeed);
			},
			/**
			 * Set a new Internet Speed
			 *
			 * @param newSpeed - Int
			 */
			setInternetSpeed: function (newSpeed) {
				internetSpeed = newSpeed;
				this.updateUI(fileSize, internetSpeed);
			},

			/**
			 * Reset the loading bar and start the animation after a delay time
			 * so it's more visible to the user what is happening.
			 */
			startAnimation: function () {
				this.resetBar();

				this.animationStartDelay = setTimeout(this.animate.bind(this), 250);
			},

			/**
			 * Do the animation
			 */
			animate: function() {
				var duration = getSeconds(fileSize, internetSpeed) * 1000;
				var iterations = Math.ceil(duration / INTERVAL_STEP);
				var count = 0;
				var _this = this;

				if(iterations === 0) {
					return;
				}

				this.animationTimer = setInterval(function () {
					count += 1;

					bar.progress = count / iterations;

					if (iterations === count) {
						_this.stopAnimation();
					}
				}, INTERVAL_STEP);
			},

			/**
			 * Stop the animation
			 */
			stopAnimation: function () {
				if (typeof this.animationStartDelay !== 'undefined') {
					clearTimeout(this.animationStartDelay);
				}

				if (typeof this.animationTimer !== 'undefined') {
					clearInterval(this.animationTimer);
				}
			},

			/**
			 * Reset the loading bar to 0;
			 */
			resetBar: function () {
				this.stopAnimation();
				bar.progress = 0;
			}
		});

		//init with default values
		this.updateUI(fileSize, internetSpeed);
		this.startAnimation();
	}

	/**
	 * Loading Bar
	 *
	 * @author TAAATRA1
	 * @namespace Tc.Module
	 * @class LoadingBar
	 * @extends Tc.Module
	 */
	Module.LoadingBar = Module.extend({

		on: function (callback) {
			var mod = this;

			mod.bars = [];

			mod.$ctx.find('.loader-bar').each(function () {
				mod.bars.push(new Bar($(this)));
			});

			this.storeData();
			this.cacheUi();
			this.addEventListeners();

			this.sandbox.subscribe('LOADING_BAR', this);

			callback();
		},

		addEventListeners: function(){
			if(this.ui.$observable) {
				this.ui.$observable.on('change', this.handleObservableChange.bind(this));
			}
		},

		storeData: function() {
			this.observableId = this.$ctx.data('observable');
			this.observableConfig = this.$ctx.data('observable-config');
		},

		cacheUi: function(){
			this.ui = {};

			if(this.observableId) {
				this.ui.$observable = $(document.body).find('input[name="'+this.observableId+'"]');
			}
		},

		getObservableConfig: function(observableValue) {
			for(var i = 0; i < this.observableConfig.length; i += 1) {
				if(this.observableConfig[i].value === observableValue) {
					return this.observableConfig[i];
				}
			}
		},

		handleObservableChange: function(event) {
			var $field = $(event.currentTarget);
			var config = this.getObservableConfig($field.val());

			if(!config) {
				return;
			}

			if(config.fileSize) {
				this.setFileSize(parseInt(config.fileSize));
			}

			if(config.internetSpeed) {
				this.setInternetSpeed(parseInt(config.internetSpeed));
			}
		},

		/**
		 * Updates all bars to a new internet speed.
		 *
		 * @param internetSpeed - the new internet speed in Mbit/Sec
		 */
		setInternetSpeed: function(internetSpeed) {
			this.bars.forEach(function (bar) {
				bar.setInternetSpeed(internetSpeed);
				bar.startAnimation();
			});
		},

		/**
		 * Updates the files size on all bars to the supplied filesize.
		 *
		 * @param fileSize - the new filesize in MB
		 */
		setFileSize: function(fileSize) {
			this.bars.forEach(function (bar) {
				bar.setFileSize(fileSize);
				bar.startAnimation();
			});
		},

		/**
		 * Terrific message handler method.
		 * Updates the internet speed on all progress bars in this component
		 *
		 * @param data
		 */
		onUpdateInternetSpeed: function (data) {
			if (!data || !data.internetSpeed) {
				return;
			}

			this.setInternetSpeed(data.internetSpeed);
		},

		/**
		 * Terrific message handler method.
		 * Updates the file size on all progress bars in this component
		 *
		 * @param data
		 */
		onUpdateFileSize: function (data) {
			if (!data || !data.fileSize) {
				return;
			}

			this.setFileSize(data.fileSize);
		}
	});
}(window.Tc.Module, window.Tc.$));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.LoadingBar.js
// module id = 151
// module chunks = 0